import { Reveal, Overline } from "./Reveal";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "Team-X operated as a true extension of our engineering org. Their end-to-end delivery took us from architecture to production faster than we thought possible.",
    name: "A. Sharma",
    role: "VP of Engineering",
    org: "Enterprise Technology Leader",
  },
  {
    quote: "The automation platform they built cut our manual testing effort dramatically. Deeply capable across telecom and industrial systems.",
    name: "M. Okafor",
    role: "Engineering Manager",
    org: "Industrial Systems",
  },
  {
    quote: "As a service provider, reliability is everything. Their managed services and 5G network automation work have been rock solid.",
    name: "L. Fernandes",
    role: "Head of Network Operations",
    org: "Service Provider",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="relative z-10 border-t border-white/10 bg-ink-950 py-24 md:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <Reveal><Overline>Testimonials</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
              Voices from the teams we build with.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <span className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-zinc-500">
            Sample content
          </span>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {testimonials.map((t, i) => (
          <Reveal
            key={t.name}
            delay={i * 0.08}
            className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition-all duration-500 hover:border-brand/30 hover:bg-white/[0.04]"
            data-testid={`testimonial-${i}`}
          >
            <Quote className="h-8 w-8 text-brand/40" />
            <p className="mt-6 flex-1 text-base leading-relaxed text-zinc-300">"{t.quote}"</p>
            <div className="mt-8 border-t border-white/10 pt-5">
              <div className="font-display text-base font-semibold text-white">{t.name}</div>
              <div className="text-sm text-zinc-500">{t.role} · {t.org}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
